// code of a current country
export const countryCode = "vn"

// (optional) if the country has more than 1 timezone
export const exactTimezone = "+5" // [+/-]<offset>

// country name, city, region, etc.
export const location = "Vietnam"

// locations and dates, if any
export const plans = "Southeast Asia on motorcycle"

// one of the working statuses:
// 1 - 👀 open to anything
// 2 - 😎 open to long-term
// 3 - ⚡ open to short-term
// 4 - 🤔 busy, but open for future
// 5 - 🔥 busy, not responding
// 6 - 😴 unable to work
// 7 - 😌 no more projects
// 8 - 🏝️ on vacation
// 9 - 🍄 hermit mode
export const freelanceStatus = 4

// (optional) e.g. "Jan 1" or "~ Jan 1" or "Jan 1 – Jan 6" 
export const dateOfStartResponding = "" 
export const dateOfStartRespondingRu = "" 
